module.exports = __webpack_public_path__ + "media/bg.cf182503.mp4";